import { GET } from '@/helpers';
import { StrapiResponse, StrapiSbornikResponse } from '@/types';

export class SbornikApi {
  private CONTACTS_BACKEND_API: string;
  constructor() {
    this.CONTACTS_BACKEND_API = process.env.NEXT_PUBLIC_API_URL + '/sborniks'!;
  }

  async getSbornik(): Promise<StrapiResponse<StrapiSbornikResponse> | { error: string }> {
    return GET(this.CONTACTS_BACKEND_API + '?populate=document,imageUrl&sort[date]=desc');
  }
}
